var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSpinner(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 8C15 6.61553 14.5895 5.26215 13.8203 4.11101C13.0511 2.95986 11.9579 2.06266 10.6788 1.53284C9.3997 1.00303 7.99223 0.864406 6.63437 1.1345C5.2765 1.4046 4.02922 2.07129 3.05025 3.05025C2.07128 4.02922 1.4046 5.2765 1.1345 6.63437C0.864406 7.99223 1.00303 9.3997 1.53284 10.6788C2.06266 11.9579 2.95986 13.0511 4.11101 13.8203C5.26215 14.5895 6.61553 15 8 15",
    stroke: "url(#red-spinner)",
    strokeLinecap: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "white-spinner",
    x1: 15,
    y1: 4.4716,
    x2: 4.71265,
    y2: 17.4167,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.427083,
    stopColor: "#fff",
    stopOpacity: 0.5573
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0.3
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "red-spinner",
    x1: 15,
    y1: 4.4716,
    x2: 4.71265,
    y2: 17.4167,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#c00d0d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.427083,
    stopColor: "#c00d0d",
    stopOpacity: 0.5573
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c00d0d",
    stopOpacity: 0.3
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpinner);
export default __webpack_public_path__ + "static/media/spinner.9a6eac227724750264e7e0491e82f4bc.svg";
export { ForwardRef as ReactComponent };